<div class="flex flex-col overflow-auto h-full gap-4">
  <div>
    @if (diagnosisSessionId) {
      <app-review-selected-challanges [diagnosisSessionId]="diagnosisSessionId"></app-review-selected-challanges>
    }
  </div>

  <div class="flex flex-col flex-1 h-px overflow-auto gap-4 px-5 pb-5">
    <div class="flex items-center justify-between">
      <div class="input-title">
        <h2 class="text-xl font-semibold">Inputs</h2>
      </div>

      <div class="clear-all-wrapper">
        <p-button
          class="clear-all-button"
          label="Clear All"
          (click)="clearAllSelections()"
          [ngClass]="{ 'clear-btn-disabled': !isEnableClearAllBtn() }"
          [disabled]="!isEnableClearAllBtn()"
        />
      </div>
    </div>

    <form
      id="input-form"
      [formGroup]="inputSolution"
      class="overflow-auto h-px min-[1400px]:flex-1 max-[1400px]:h-[50vh]"
      [appLoading]="!entryCategories.length"
    >
      @for (cate of entryCategories; track $index; let idx = $index) {
        @if (requiredInputs[cate.name]) {
          @let isInputControlValid = isInputControl(cate.inputType.uiControlName!);

          <div class="input-solution" [ngClass]="{ 'input-temperature-solution': isInputControlValid }">
            @if (isInputControlValid) {
              <label class="input-solution-title" [for]="cate.name">{{ cate.name }}:</label>
              <div class="input-container">
                <input
                  type="number"
                  [id]="cate.name"
                  [name]="cate.name"
                  formControlName="input{{ cate.name }}"
                  pInputText
                  placeholder="Input number"
                  class="input-solution_field custom-input-text w-full"
                  [ngClass]="{ 'disabled-input': isDisabledDropdown() }"
                  (change)="onTextInputChanged($event, cate)"
                />
                <p-select
                  appendTo="body"
                  [id]="cate.name"
                  [formControlName]="cate.name"
                  [options]="requiredInputs[cate.name]"
                  [placeholder]="getDefaultValue(cate)"
                  styleClass="input-solution-select custome-select"
                  (onChange)="onDropdownChanged($event, cate)"
                  [ngClass]="{
                    'temperature-select': isInputControlValid,
                    'disabled-select': isDisabledDropdown(),
                  }"
                />
              </div>
            } @else {
              <p class="input-solution-title">{{ cate.name }}:</p>
              <p-select
                appendTo="body"
                [id]="cate.name"
                [formControlName]="cate.name"
                [options]="requiredInputs[cate.name]"
                [placeholder]="getDefaultValue(cate)"
                styleClass="input-solution-select custome-select"
                (onChange)="onDropdownChanged($event, cate)"
                [showClear]="isInputControlValid ? false : true"
                [ngClass]="{
                  'disabled-select': isDisabledDropdown(),
                }"
              />
            }
          </div>
        }
      }
    </form>
  </div>
</div>
